import React, { useState, useEffect, useContext } from "react";
// import styled from "styled-components";
import { Link } from "react-router-dom";
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/img/logo/logo-smart-white.png";
import { XCircleFill } from 'react-bootstrap-icons';
import styles from '../../assets/css/module/common/common.module.css';
import {NavContext,LanguageContext} from '../context/NavContext';

const Sidebar = ({ sidebaropen, toggleSidebar }) => {
  const { nav, setNav } = useContext(NavContext);
  function toggleMenu(x) {
    setNav(x)
    toggleSidebar(!sidebaropen)
  }
  return (
    <div className={`${styles["side-bar"]}`}>
      <div className={`${styles["side-bar-header"]}`}>
        {/* <div className="side-bar-logo-container">
          <img src={LogoIcon} alt="logo" className="side-bar-logo" />
        </div> */}
        <button onClick={() => toggleSidebar(!sidebaropen)} className={`${styles["side-bar-close-btn"]} ${styles["btn"]}`}>
          <XCircleFill />
        </button>
      </div>

      <nav className={`${styles["side-bar-nav"]}`}>
        <ul>
          <li >
            <Link
              onClick={() => toggleMenu('home')}
              // activeClass="active"
              // className="whiteColor"
              className={`${styles["side-bar-menu"]} ${nav === 'home' ? styles['side-bar-menu-active'] : ''}`}
              style={{ padding: "10px 15px" }}
              to="/home"
              // spy={true}
              // smooth={true}
              offset={-60}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={() => toggleMenu('news')}
              // activeClass="active"
              className={`${styles["side-bar-menu"]} ${nav === 'news' ? styles['side-bar-menu-active'] : ''}`}
              style={{ padding: "10px 15px" }}
              to="/news"
              // spy={true}
              // smooth={true}
              offset={-60}
            >
              News
            </Link>
          </li>
          <li>
            <Link
              onClick={() => toggleMenu('career')}
              // activeClass="active"
              className={`${styles["side-bar-menu"]} ${nav === 'career' ? styles['side-bar-menu-active'] : ''}`}
              style={{ padding: "10px 15px" }}
              to="/career"
              // spy={true}
              // smooth={true}
              offset={-60}
            >
              Career
            </Link>
          </li>
          <li >
            <Link
              onClick={() => toggleMenu('about')}
              // activeClass="active"
              className={`${styles["side-bar-menu"]} ${nav === 'about' ? styles['side-bar-menu-active'] : ''}`}
              style={{ padding: "10px 15px" }}
              to="/about"
              // spy={true}
              // smooth={true}
              offset={-60}
            >
              About Us
            </Link>
          </li>
          <li >
            <Link
              onClick={() => toggleMenu('contact')}
              // activeClass="active"
              className={`${styles["side-bar-menu"]} ${nav === 'contact' ? styles['side-bar-menu-active'] : ''}`}
              style={{ padding: "10px 15px" }}
              to="/contact"
              // spy={true}
              // smooth={true}
              offset={-60}
            >
              Contact
            </Link>
          </li>
        </ul>

      </nav>
    </div>
  );
}

export default Sidebar;
